export const SITE_URL = 'https://autopostmate.com';
export const TERMS_URL = `${SITE_URL}/terms.html`;
export const PRIVACY_URL = `${SITE_URL}/privacy.html`;

interface LegalLinksProps {
  /** The action the reader is about to take, e.g. "creating an account". */
  action: string;
}

/** The agreement line under an auth form: "By {action} you agree to the Terms
 *  of Service and Privacy Policy." Both open the landing site in a new tab. */
export function LegalLinks({ action }: LegalLinksProps) {
  return (
    <p className="auth-legal">
      By {action} you agree to the{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  );
}
